import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { AppLeftNavProps } from './AppLeftNav';

const AppLeftNav = () =>
  import(/* webpackChunkName: "4-feat-mobile-nav-overlay" */ './AppLeftNav').then((m) => ({ default: m.AppLeftNav }));

const LoadableAppLeftNav: ComponentType<AppLeftNavProps> = lazyLoadOnRender({ loader: AppLeftNav });
export default LoadableAppLeftNav;
